import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "../src/store/index";

import i18n from "./i18n";

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import VueInputAutowidth from "vue-input-autowidth";
Vue.use(VueInputAutowidth);

import VueTippy from "vue-tippy";
import "tippy.js/themes/light.css";
Vue.use(VueTippy);

import { StripePlugin } from "@vue-stripe/vue-stripe";

/* FIREBASE */
// if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
// import firebaseMessaging from "./firebase";
// const { firebaseMessaging } = require("./firebase");
// Vue.prototype.$messaging = firebaseMessaging;
// }

/* STRIPE */
const options = {
  pk: process.env.VUE_APP_STRIPE_PK,
  testMode: process.env.VUE_APP_STRIPE_TESTMODE, // Boolean. To override the insecure host warning
  apiVersion: process.env.VUE_APP_STRIPE_APIVERSION,
};

Vue.use(StripePlugin, options);

// import Hotjar from "vue-hotjar";
// Vue.use(Hotjar, {
//   id: "1898848",
//   isProduction: true, //set to true in production
//   snippetVersion: 6,
// });

// import VueAnalytics from "vue-analytics";
// Vue.use(VueAnalytics, {
//   id: "UA-3341499-28",
//   router,
// });

import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_SITE_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
  },
});

import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
Vue.use(PerfectScrollbar);

import autofocus from "vue-autofocus-directive";
Vue.directive("autofocus", autofocus);

import VueForceNextTick from "vue-force-next-tick";
Vue.use(VueForceNextTick);

import Ripple from "vue-material-design-ripple";
Vue.directive("ripple", Ripple);

import LottieVuePlayer from "@lottiefiles/vue-lottie-player";
Vue.use(LottieVuePlayer);

import VCalendar from "v-calendar";
Vue.use(VCalendar, {
  componentPrefix: "vc",
  masks: { weekdays: "WWW" },
  titlePosition: "left",
});

Vue.mixin({
  computed: {
    cname_domain() {
      return this.$store.getters.getCname;
    },
    domain() {
      return this.$store.getters.getDomain;
    },
    external_link() {
      return this.$store.getters.getExternalLink;
    },
  },
});

router.beforeEach((to, from, next) => {
  if (window.localStorage.getItem("token")) {
    if (store && store.getters && store.getters.getMe) {
      if (store.getters.getMe.account_type == "basic") {
        if (!["Upgrade", "Payment Success", "Setting", "Settings"].includes(to.name)) {
          next("/upgrade");
          return;
        }
      }
    }
  }
  next();
});

Vue.config.devtools = process.env.VUE_APP_DEVTOOLS;
Vue.config.debug = process.env.VUE_APP_DEBUG;
Vue.config.silent = process.env.VUE_APP_SILENT;
Vue.config.productionTip = false;
Vue.component("Draggable", () => import("vuedraggable"));
Vue.component("Loading", () => import("@/components/Loading.vue"));
Vue.component("TextField", () => import("@/components/TextField.vue"));
Vue.component("TextArea", () => import("@/components/TextArea.vue"));
Vue.component("Dropdown", () => import("@/components/Dropdown.vue"));
Vue.component("Switcher", () => import("@/components/Switcher.vue"));
Vue.component("Radio", () => import("@/components/Radio.vue"));
Vue.component("Counter", () => import("@/components/Counter.vue"));
Vue.component("Checkbox", () => import("@/components/Checkbox.vue"));
Vue.component("RadioBox", () => import("@/components/RadioBox.vue"));
Vue.component("CircleBox", () => import("@/components/CircleBox.vue"));
Vue.component("Button", () => import("@/components/Button.vue"));
Vue.component("Slider", () => import("@/components/Slider.vue"));
Vue.component("Avatar", () => import("@/components/Avatar.vue"));
Vue.component("Modal", () => import("@/components/Modal.vue"));
Vue.component("Alert", () => import("@/components/Alert.vue"));
Vue.component("Helper", () => import("@/components/Helper.vue"));

Vue.component("ColorPicker", () => import("@/components/ColorPicker.vue"));
Vue.component("CheckAnimation", () => import("@/components/CheckAnimation.vue"));
Vue.component("DragToScroll", () => import("@/components/DragToScroll.vue"));

Vue.component("Topnav", () => import("@/components/Topnav.vue"));

var app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  data: () => ({}),
  beforeMount() {},
  computed: {},
  watch: {},
  methods: {},
}).$mount("#app");

// For ios
const windowHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty("--window-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", windowHeight);
windowHeight();
